export const MdmCreateOfficeFormKeys = {
  officeName: "officeName",
  parentOfficeId: "parentOfficeId",
  officeCode: "officeCode",
  officeType: "officeType",
  marketId: "marketId",
  regionId: "regionId",
  billingOfficeId: "billingOfficeId",
  salesCreditOfficeId: "salesCreditOfficeId",
  currencyId: "currencyId",
  invoiceTemplateId: "invoiceTemplateId",
  salesCreditTemplateId: "salesCreditTemplateId",
  defaultTax: "defaultTax",
  statusId: "statusId",
  businessUnitId: "businessUnitId",
  timeZoneKey: "timeZoneKey",
  address1: "address1",
  address2: "address2",
  address3: "address3",
  countryId: "countryId",
  city: "city",
  state: "state",
  postalCode: "postalCode",
  isBillingOffice: "isBillingOffice",
  isSalesCreditOffice: "isSalesCreditOffice",
  header: "header",
  footer1: "footer1",
  footer2: "footer2",
  footer3: "footer3",
} as const;

export const AccordionTitleKeys = {
  officeDetails: "officeDetails",
  addressAndContactDetails: "addressAndContactDetails",
  invoicingDetails: "invoicingDetails",
  all: "all",
} as const;

export type CreateOfficeSectionTypes =
  | "officeDetails"
  | "addressDetails"
  | "invoicingDetails"
